import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ChooseProject from './ChooseProject';
import RecentProjects from './RecentProjects';
import ProductsNews from './ProductsNews';

class Welcome extends React.Component {

    render() {

        return (
            <Row style={{ height: '100%', marginLeft: '0', marginRight: '0' }}>
                <Col sm={4} className="col-welcome">
                    <ChooseProject />
                </Col>
                <Col sm={4} className="col-welcome">
                    <RecentProjects />
                </Col>
                <Col sm={4} className="col-welcome">
                    <ProductsNews brandName={this.props.brandName}/>
                </Col>
            </Row>
        );
    }
};

export default Welcome;
